export default __webpack_public_path__ + "static/char-t-20-ko-408536b7a9a7a25b672c69e87e86d4ce.png";